<template>
    <div class="tendency_chart fs14">
        <p v-if="hasTitle" class="homeComTitle flex_box" :class="[ imgClass ]">
            <span class="flex_1">{{ title }}</span>
            <span v-if="hasHint" class="fs12 co_B0 font_n mr16">{{ hintMsg }}</span>
        </p>
        <section v-if="channelStats.length > 0">
            <p v-if="defaultContent" class="mag" v-html="defaultContent"></p>
            <p v-else-if="!slotmag" class="mag" v-html="content"></p>
            <slot v-if="slotmag"></slot>
            <div class="channel_stats_chart" :id="chartBox"></div>
        </section>
        <img v-else class="noDataImg mt28" src="../../assets/img/company/noData.svg" alt="">
    </div>
</template>

<script>

let echarts = require('echarts');
import _ from "loadsh";
import common from "../../util/common";

export default {
    name: 'TendencyChart',
    props: {
        channelStats: Array,
        slotmag: {
            type: Boolean,
            default: false
        },
        chartBox: {
            type: String,
            default: "channelStatsChart"
        },

        hasTitle: Boolean,
        title: {
            type: String,
            default: '渠道报道倾向'
        },
        imgClass: {
            type: String,
            default: 'chartText'
        },
        hasHint: Boolean,
        hintMsg: {
            type: String,
            default: '注：排名不分先后'
        },
        periodStr: {
            type: String,
            default: "日"
        },
        defaultContent: String,
        entityType: String,
        entity: String
    },
    data() {
        return {
            content: "",
            list: [],
            yAxisData: [],
            tendencyStats: {
                total: 0,
                positive: 0,
                negative: 0,
                neutral: 0
            },
            positive: [],
            negative: [],
            neutral: [],
            negativePercent: 0,
            positivePercent: 0,

        }
    },
    watch: {
        "entity": function (pre, cur) {
            if (pre && cur && cur.length > 0)
                this.renderFunc()
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        initData: function () {
            this.yAxisData = [];
            this.tendencyStats = {
                total: 0,
                positive: 0,
                negative: 0,
                neutral: 0
            };
            this.positive = [];
            this.negative = [];
            this.neutral = [];
            this.negativePercent = 0;
            this.positivePercent = 0;
        },
        renderFunc: function () {
            let self = this;
            let list = _.orderBy(this.channelStats, ["level", "negative"], ["desc", "asc"]);

            self.initData();
            list.forEach((item) => {
                this.yAxisData.push(item.name)
                this.positive.push(item.positive)
                this.negative.push(item.negative)
                this.neutral.push(item.neutral)
                this.tendencyStats.total += item.total
                this.tendencyStats.positive += item.positive
                this.tendencyStats.negative += item.negative
                this.tendencyStats.neutral += item.neutral

            })
            this.list = list;//！！pdf 使用
            self.negativePercent = common.formatPercentAndCeil(self.tendencyStats.negative, self.tendencyStats.total);
            self.positivePercent = common.formatPercentAndCeil(self.tendencyStats.positive, self.tendencyStats.total);


            if(!this.slotmag){
                let dateStr = common.formatDateStr(this.periodStr);
                let content = `${dateStr},${common.convertEntityNameStr(this.entity, this.entityType)}暂无媒体报道。`;
                if (this.tendencyStats.total) {
                    let negativePercent = this.tendencyStats.negative === this.tendencyStats.total ? 100 : common.formatPercentAndCeil(this.tendencyStats.negative, this.tendencyStats.total);
                    let otherPercent = 100 - negativePercent;
                    let otherTotal = this.tendencyStats.neutral + this.tendencyStats.positive;
                    content = `${dateStr}，${common.convertEntityNameStr(this.entity, this.entityType)}${this.entityType=="company" ?"舆情主体性报道":"舆情报道"}${this.chartBox == "manager" ? "中涉及高管的报道":""}<b>${ this.tendencyStats.total }篇</b>，其中敏感报道<b>${ this.tendencyStats.negative }篇</b>`;
                    content += this.tendencyStats.negative ? `，占<b>${negativePercent}%</b>；` : '；';
                    content += `正面及中性报道<b>${otherTotal}篇</b>`;
                    content += otherTotal ? `，占<b>${otherPercent}%</b>。` : '。';
                    if (this.tendencyStats.negative) {
                        let maxChannel = _.maxBy(this.list, 'negative');
                        let percent = this.tendencyStats.negative === maxChannel.negative ? 100 : common.formatPercentAndCeil(maxChannel.negative, this.tendencyStats.negative);
                        content += `敏感报道的核心发布渠道为<b>${maxChannel.name}</b>，该渠道敏感报道量约占${dateStr}${common.convertEntityName(this.entity, this.entityType)}敏感报道总量的<b>${percent}%</b>。`
                    }
                }

                this.content = `${content}`;
            }


            let chart = echarts.init(document.getElementById(self.chartBox));


            let xAxis = {
                type: 'value',

                axisLine: { //  改变y轴颜色
                    show: false,
                    lineStyle: {
                        color: "#6E7079",
                    }
                },
                // interval: 4000,
                // max: 20000,
                axisLabel: { //  改变y轴字体颜色和大小
                    textStyle: {
                        color: "#6E7079",
                        fontSize: 10,
                    },
                    formatter: function (count) {
                        if(count % 10000 == 0  && Math.log10(count) >=4 && count){
                            return  `${count / 10000}万`
                        }
                        return  `${count}`
                    },

                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#C9C9CA',
                        width: 1,
                        type: 'dotted'
                    }
                }
            }

            // if(this.tendencyStats.total > 40000){
            //     xAxis.interval = 20000;
            //     xAxis.max = 120000;
            // }
            let option = {
                color: ['#FB7361', '#FEBB32', '#65DE8E'],
                center: ["50%", "70%"],
                grid: {
                    top: '10%',
                    left: '0%',
                    right: '13%',
                    bottom: '3%',
                    containLabel: true
                },
                legend: {
                    top: 0,
                    left: 0,
                    itemWidth: 3,
                    itemHeight: 3,
                    selectedMode: false,
                    // itemStyle: {
                    //     borderColor: '#65DE8E',
                    //     borderWidth: 0.5
                    // },
                    orient: 'horizontal',
                    textStyle: {
                        fontSize: 10,
                        // color: '#FEBB32',
                        // padding: [3, 0, 0, 0]
                    },
                    data: [{
                        name: '敏感报道',
                        textStyle: {
                            color: '#FB7361'
                        }
                    }, {
                        name: '中性报道',
                        textStyle: {
                            color: '#FEBB32'
                        },
                    }, {
                        name: '正面报道',
                        textStyle: {
                            color: '#65DE8E'
                        },
                    }]
                },
                yAxis: [{
                    type: 'category',
                    nameTextStyle: {
                        color: '#6E7079',
                        fontWeight: 'bold',
                        fontSize: 10,
                        align: 'left',
                        padding: [0, 0, 0, 220]
                    },
                    data: this.yAxisData,
                    axisLine: { //  改变x轴颜色
                        lineStyle: {
                            color: "rgba(256,256,256,0)",
                        }
                    },
                    // nameTextStyle: {
                    //     color: 'rgba(256,256,256,0.85)',
                    //     fontWeight: 'bold',
                    //     fontSize: 10
                    // },
                    axisLabel: { //  改变x轴字体颜色和大小
                        textStyle: {
                            color: "#6E7079",
                            fontSize: 12

                        },
                        interval: 0,
                        // rotate:40 ,
                        grid: {
                            left: '10%',
                            bottom: '35%'
                        },
                    }

                }, {
                    type: 'category',
                    name: '报道量(篇）',
                    axisLine: { //  改变x轴颜色
                        lineStyle: {
                            color: "rgba(256,256,256,0)",
                        }
                    },
                    nameTextStyle: {
                        color: '#6E7079',
                        fontWeight: 'bold',
                        fontSize: 10,
                        align: 'right',
                    },
                    axisLabel: { //  改变x轴字体颜色和大小
                        textStyle: {
                            color: "#6E7079",
                            fontSize: 10
                        },
                        interval: 0,
                        // rotate:40 ,
                        grid: {
                            left: '10%',
                            bottom: '35%'
                        },
                    },
                }],
                xAxis: xAxis,
                series: [
                    {
                        name: '敏感报道',
                        type: 'bar',
                        stack: '总量',
                        barWidth: 16,
                        label: {
                            show: false,
                            position: 'right'
                        },
                        itemStyle: {
                            normal: {
                                color: '#FB7361',
                                borderColor: '#FB7361',
                                borderWidth: 0.5,
                                // color: '#376CCF',  //圈圈的颜色
                                // barBorderRadius: [20, 0, 0, 20],
                            }
                        },
                        data: this.negative
                    },
                    {
                        name: '中性报道',
                        type: 'bar',
                        stack: '总量',
                        barWidth: 16,
                        label: {
                            show: false,
                            position: 'right'
                        },
                        itemStyle: {
                            normal: {
                                color: '#FEBB32',
                                borderColor: '#FEBB32',
                                borderWidth: 0.5,
                                // color: '#87A7E2',  //圈圈的颜色
                            }
                        },
                        data: this.neutral
                    },
                    {
                        name: '正面报道',
                        type: 'bar',
                        stack: '总量',
                        label: {
                            show: true,
                            position: 'right',
                            color: "#6E7079",
                            fontWeight: '500',
                            fontSize: 12,
                            formatter: function (params) {
                                let total = params.value + self.negative[params.dataIndex] + self.neutral[params.dataIndex];

                                return  `${total}`
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#65DE8E',
                                borderColor: '#65DE8E',
                                borderWidth: 0.5,
                                // color: '#C3D2F0',  //圈圈的颜色
                                // barBorderRadius: [0, 20, 20, 0],
                            },
                        },
                        data: this.positive
                    }
                ]
            };

            chart.setOption(option);
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.renderFunc()
        })
    }
}
</script>

<style lang="scss" scoped>
.tendency_chart {
    box-sizing: border-box;
    background-color: #FFFFFF;

    .mag {
        margin-right: 16px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333333;
        margin-top: 12px;
    }

    .channel_stats_chart {
        margin-top: 28px;
        width: 100%;
        height: 300px;
        //padding: 0px 26px;
    }

}
</style>